// @flow

export const STATUS = {
  AVAILABLE: "available",
  UNAVAILABLE: "unavailable",
  CLOSED: "service_window_closed",
  FARE_CATEGORY_UNSUPPORTED: "fare_category_unsupported",
  ALL_ASSIGNED: "all_assigned",
}

export type SeatingStatus = $Values<typeof STATUS>

export const PRICE_TYPES = {
  CHEAP: "cheap",
  NORMAL: "normal",
  EXPENSIVE: "expensive",
}

export const UNAVAILABLE_NOTES = {
  [STATUS.UNAVAILABLE]: __("booking_seating.flight.seating_unavailable"),
  [STATUS.CLOSED]: __("booking_seating.flight.seating_closed"),
}

export const UNAVAILABLE_PAGE_NOTES = {
  [STATUS.AVAILABLE]: "available", // never displayed, here because of flow
  [STATUS.UNAVAILABLE]: __("booking_seating.flight.seating_unavailable_long"),
  [STATUS.CLOSED]: __("booking_seating.flight.seating_closed_long"),
  [STATUS.FARE_CATEGORY_UNSUPPORTED]: "fare_category_unsupported", // never displayed, here because of flow
  [STATUS.ALL_ASSIGNED]: "all_assigned", // never displayed, here because of flow
}

export const SEAT_STATES = {
  AVAILABLE: "available",
  OCCUPIED: "occupied",
}
